// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"BIBLE-CLUBS-module--previewTitle--SwkUV","tag":"BIBLE-CLUBS-module--tag--2UeTB"};